import Angular from 'angular';
import Controller from "./vehicle-details.controller";
import Template from './vehicle-details.html';
import Vehicles from '../../services/vehicles.service';
import Bookings from '../../services/bookings.service';
import VehicleCheckIcon from '../../components/vehiclecheck-state-icon/vehiclecheck-state-icon';
import BookingStateIcon from "../../components/bookinst-state-icon/booking-state-icon";

export const VehicleDetailsView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};


export default Angular.module('view.vehicle-details', [
    Vehicles.name,
    Bookings.name,
    VehicleCheckIcon.name,
    BookingStateIcon.name
]);



// WEBPACK FOOTER //
// ./src/modules/main/views/vehicle-details/vehicle-details.js